import React, { useEffect, useState } from 'react';
import { dynastyTheme } from '../../../services/colorService';
import { mobilePageBackground } from '../../../services/mobileStyleService';
import { playBatCrack, triggerVibration, generateConfettiPiece } from './baseballAssets';

const MobileAuthSuccess = ({ message = 'Welcome to Dynasty Dugout!', userName = '' }) => {
  const [confetti, setConfetti] = useState([]);

  useEffect(() => {
    // Play sound and vibrate on mount
    playBatCrack();
    triggerVibration([200, 100, 200]); // Vibrate-pause-vibrate pattern

    // Generate confetti pieces
    const pieces = Array.from({ length: 30 }, () => generateConfettiPiece());
    setConfetti(pieces);
  }, []);

  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden"
      style={{ background: mobilePageBackground }}
    >
      {/* Confetti Animation */}
      {confetti.map((piece, index) => (
        <div
          key={index}
          className="absolute text-4xl pointer-events-none"
          style={{
            left: `${piece.x}%`,
            top: '-10%',
            animation: `confettiFall ${piece.duration}s linear ${piece.delay}s forwards`,
            transform: `rotate(${piece.rotation}deg)`
          }}
        >
          {piece.emoji}
        </div>
      ))}

      {/* Success Content */}
      <div className="z-10 text-center px-6">
        {/* Stadium Icon */}
        <div className="text-6xl mb-4 animate-bounce">
          🏟️
        </div>

        {/* Success Message */}
        <h1 className={`text-2xl font-bold mb-2 ${dynastyTheme.classes.text.white}`}>
          {userName ? `Welcome, ${userName}!` : message}
        </h1>

        <p className={`text-base ${dynastyTheme.classes.text.neutralLighter}`}>
          Loading your dugout...
        </p>

        {/* Trophy Animation */}
        <div className="mt-6 text-5xl animate-pulse">
          ⚾ 👑 ⚾
        </div>
      </div>

      {/* CSS for confetti animation */}
      <style jsx>{`
        @keyframes confettiFall {
          0% {
            transform: translateY(0) rotate(0deg);
            opacity: 1;
          }
          100% {
            transform: translateY(110vh) rotate(720deg);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default MobileAuthSuccess;
